/**
 * 全局存放数据
 * 
 * @author 张子超
 * @since 2018-04-04
 */
import Vue from 'vue'


var store = {
    //常量
    Enums: {
        ProductTypes: [
            { title: '娱乐机', value: '1' },
            { title: '礼品机', value: '2' },
            { title: '中性机', value: '3' }
        ]
    },
    Codes: {
        OK: 0,
        NetworkCrash: -99999,
        NotLogin: -21,
        ParamError: -12,
    },
    //当前登录用户
    loginedUser: null,
    currentFactory: null,
    myFactoryList: [],
    present: 0,
    active:true  //显示转盘， 每日首次兑换

};

store.getProductType = function(val){
    for (const i in store.Enums.ProductTypes) {
        if (store.Enums.ProductTypes.hasOwnProperty(i)) {
            const element = store.Enums.ProductTypes[i];
            if(element.value == val){
                return element;
            }
        }
    }
    return null;
}

Vue.prototype.Store = store;

export default store


// WEBPACK FOOTER //
// ./src/api/store.js